import { connect } from 'react-redux'
import { Link } from 'react-router'
import styles from './style.css'
import ForgotPasswordForm from './ForgotPasswordForm'
import { forgotPassword } from 'actions'

class ForgotPassword extends React.Component {
  render () {
    let {dispatch} = this.props
    let {currentlySending, error} = this.props.data.moka

    return (
      <div>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-6 col-sm-offset-3'>
              <div className={styles.root}>
                <h1 className={styles.title}>
                  Forgot Password?
                </h1>
                <hr />
                <ForgotPasswordForm
                  dispatch={dispatch}
                  history={this.props.history}
                  onSubmit={this.handleSubmit}
                  error={error}
                  currentlySending={currentlySending}
                />
                <div className='visible-lg visible-md'>
                  <p id='sign-in' className={styles['no-account']}>
                    Don&#39;t have a Moka account?
                  <Link to='/register'> Sign Up </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleSubmit = (values) => {
    let {email} = values
    this.props.dispatch(forgotPassword({email}))
  }
}

ForgotPassword.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  dispatch: React.PropTypes.func
}

function select (state) {
  return {
    data: state
  }
}

export default connect(select)(ForgotPassword)



// WEBPACK FOOTER //
// ./app/pages/ForgotPassword/ForgotPassword.js